import type { DetailType } from 'components/DetailsViewCardHeader/types';

export const TEST_ID = 'detailsViewEntityLink';

export const ENTITY_TYPE_LABELS: Record<DetailType, string> = {
    application: 'APPLICATION',
    battery: 'BATTERY',
    boundary: 'BOUNDARY',
    chemical: 'CHEMICAL',
    city: 'CITY',
    classification: 'CLASSIFICATION',
    client: 'CLIENT',
    contactName: 'CONTACT NAME',
    controllerSerialNumber: 'CNTLR. S/N',
    crop: 'CROP',
    drone: 'DRONE',
    droneSerialNumber: 'DRONE S/N',
    email: 'EMAIL',
    epaNumber: 'EPA NUMBER',
    estimatedAcres: 'EST. ACRES',
    faaRegistrationNumber: 'FAA REG #',
    farm: 'FARM',
    field: 'FIELD',
    flightControllerFirmwareVersion: 'FIRMWARE',
    flightHours: 'FLIGHT HRS',
    formulation: 'FORMULATION',
    manufacturer: 'MANUFACTURER',
    mix: 'MIX',
    modeOfAction: 'MODE OF ACTION',
    numberOfFlights: 'FLIGHTS',
    phone: 'PHONE',
    pilot: 'PILOT',
    ppe: 'PPE',
    ppeReentry: 'PPE REENTRY',
    rainfastness: 'RAINFASTNESS',
    rei: 'REI',
    role: 'ROLE',
    scheduledPilot: 'SCHEDULED PILOT',
    serialNumber: 'BATT S/N',
    signalWord: 'SIGNAL WORD',
    source: 'SOURCE',
    state: 'STATE',
    status: 'STATUS',
    targetPest: 'TARGET PEST',
    totalAcres: 'T. ACRES',
    totalAreaApplied: 'AREA APPLIED',
    totalVolumeApplied: 'VOLUME APPLIED',
    user: 'USER',
    warrantyEndDate: 'WTY. END',
    warrantyRemaining: 'WTY. RMNG',
    warrantyStartDate: 'WTY. START',
    zip: 'ZIP'
};
